
import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function eyeInvert(props:any) {
    return (

            <SvgIcon {...props}>
            <path d="M5.14246 3.04224C2.23037 4.51692 1 7.28555 1 7.28555C1 7.28555 3.28571 12.4279 9 12.4279C10.3389 12.4385 11.661 12.1301 12.857 11.5282" />
            <path d="M5.14246 3.04224C2.23037 4.51692 1 7.28555 1 7.28555C1 7.28555 3.28571 12.4279 9 12.4279C10.3389 12.4385 11.661 12.1301 12.857 11.5282" stroke="#FEFEFF" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.7586 10.2217C16.3158 8.82688 17.0007 7.286 17.0007 7.286C17.0007 7.286 14.715 2.14259 9.00074 2.14259C8.50583 2.14178 8.0117 2.18202 7.52344 2.26289" stroke="#FEFEFF" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.53711 4.47925C10.1444 4.59586 10.6975 4.90622 11.1134 5.36377C11.5294 5.82133 11.7857 6.40141 11.8441 7.01701" stroke="#FEFEFF" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
            <path d="M10.9215 9.39989C10.3608 9.90954 9.62058 10.1756 8.86372 10.1395C8.10685 10.1034 7.39531 9.7682 6.88562 9.20753C6.37592 8.64686 6.1098 7.90668 6.14581 7.14981C6.18182 6.39295 6.517 5.68138 7.07762 5.17163" />
            <path d="M10.9215 9.39989C10.3608 9.90954 9.62058 10.1756 8.86372 10.1395C8.10685 10.1034 7.39531 9.7682 6.88562 9.20753C6.37592 8.64686 6.1098 7.90668 6.14581 7.14981C6.18182 6.39295 6.517 5.68138 7.07762 5.17163" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.28516 1L14.7137 13.5714" stroke="#FEFEFF" strokeLinecap="round" strokeLinejoin="round"/>
            </SvgIcon>
    )
}

